import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8679bdce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pannel flex p-3" }
const _hoisted_2 = { class: "flex w-full flex-column gap-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "m-0 text-default-gray" }, "Equipements", -1))
const _hoisted_4 = { class: "flex gap-3 md:gap-5 flex-wrap mb-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex flex-column gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_ObjectTabRaw = _resolveComponent("ObjectTabRaw")!
  const _component_TagTabRaw = _resolveComponent("TagTabRaw")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabOptions, (tabOption) => {
          return (_openBlock(), _createElementBlock("span", {
            key: tabOption.id,
            class: _normalizeClass(["app-label text-gray-l1 font-bold cursor-pointer", { currentTab: _ctx.selectedTab == tabOption.id }]),
            onClick: ($event: any) => (_ctx.changeTab(tabOption.id))
          }, _toDisplayString(tabOption.label), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.itsLoading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, {
              key: 0,
              mode: "indeterminate",
              class: "h-2rem md:h-5rem"
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabContent, (object) => {
          return (_openBlock(), _createElementBlock("div", {
            key: object.id,
            class: "grid align-items-center",
            style: {"border":"1px solid #eaeef0","border-radius":"5px"}
          }, [
            (_ctx.selectedTab == 'Gateways' || _ctx.selectedTab == 'IntelligentThings')
              ? (_openBlock(), _createBlock(_component_ObjectTabRaw, {
                  key: 0,
                  data: object
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            (_ctx.selectedTab == 'Tags')
              ? (_openBlock(), _createBlock(_component_TagTabRaw, {
                  key: 1,
                  data: object
                }, null, 8, ["data"]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}